<!-- Main section -->
<section class="main_section al_storelogo">
  <div class="CP_storeLogos" id="storeLogoMainDiv">

    <!-- Data content with logo tiles in a row -->
    <div class="content__wrapper devices_page" id="devicesContent">
      <div class="tab-content" id="devicesTabs">
        <div id="devicesStoreLogo">
          <div class="d-flex flex-column h-100" id="deviceStorLogoChild">

            <div class="data_header" id="storDataHeader">
              <div class="title" id="storLogo"><span i18n="@@devices-storelogo.devices-tab.store-logo">Store Logo</span></div>
            </div>
            <div class="mb-3" id="selectLogoDisplay"><span i18n="@@devices-storelogo.devices-tab.select-store-logo">Select a logo 
              to display <strong>on all devices</strong></span>
            </div>
            <!---upload logo starts-->   
            <div class="data_header justify-content-end"  [ngClass] = "(otherStoreLogos?.length || defaultStoreLogos?.length) ? '' : 'display-block'" id="defaultStoreLogos">
              <span *ngIf="noLogosMsg"><span i18n="@@profile-storelogo.store-logos-tab.customize-message">Customize your IPOS package with your store logo. Uploaded logos will be saved to the Asset Library.</span></span><br />
              <strong><span *ngIf="noLogosMsg"><span i18n="@@profile-storelogo.store-logos-tab.no-store-logo-message">No Store Logo has been uploaded.</span></span></strong>
              <div class="data_action"  *ngIf="( this.defaultStoreLogos.length >= 1 || otherStoreLogos.length >= 1 ) ? '' : 'display-block'" id="dataAction">
                <div id="uploadButton" class="d-flex flex-column">
                  <div id="uploadBtnChild">
                  <label>
                    <input #imageInput id="uploadLogo" type="file" 
                      accept="image/jpg,image/jfif,image/x-png,image/jpeg,image/gif" (change)="processFile(imageInput)" hidden>
                    <span class="btn btn-primary btn-sm left_icon_btn"><svg width="16" height="17" viewBox="0 0 16 17"
                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M0.5 8.25822C0.632608 8.25822 0.759785 8.3109 0.853553 8.40467C0.947322 8.49844 1 8.62561 1 8.75822V12.2582C1 12.5234 1.10536 12.7778 1.29289 12.9653C1.48043 13.1529 1.73478 13.2582 2 13.2582H14C14.2652 13.2582 14.5196 13.1529 14.7071 12.9653C14.8946 12.7778 15 12.5234 15 12.2582V8.75822C15 8.62561 15.0527 8.49844 15.1464 8.40467C15.2402 8.3109 15.3674 8.25822 15.5 8.25822C15.6326 8.25822 15.7598 8.3109 15.8536 8.40467C15.9473 8.49844 16 8.62561 16 8.75822V12.2582C16 12.7887 15.7893 13.2974 15.4142 13.6724C15.0391 14.0475 14.5304 14.2582 14 14.2582H2C1.46957 14.2582 0.960859 14.0475 0.585786 13.6724C0.210714 13.2974 0 12.7887 0 12.2582V8.75822C0 8.62561 0.0526784 8.49844 0.146447 8.40467C0.240215 8.3109 0.367392 8.25822 0.5 8.25822ZM5 5.11222C5.09376 5.20596 5.22092 5.25862 5.3535 5.25862C5.48608 5.25862 5.61324 5.20596 5.707 5.11222L8 2.81822L10.293 5.11122C10.3391 5.15898 10.3943 5.19707 10.4553 5.22327C10.5163 5.24948 10.5819 5.26327 10.6483 5.26385C10.7147 5.26442 10.7805 5.25177 10.842 5.22663C10.9034 5.20149 10.9593 5.16437 11.0062 5.11742C11.0531 5.07047 11.0903 5.01465 11.1154 4.9532C11.1406 4.89175 11.1532 4.82591 11.1526 4.75952C11.152 4.69313 11.1383 4.62752 11.1121 4.56652C11.0858 4.50552 11.0478 4.45035 11 4.40422L8.354 1.75822C8.30755 1.71166 8.25238 1.67472 8.19163 1.64951C8.13089 1.6243 8.06577 1.61133 8 1.61133C7.93423 1.61133 7.86911 1.6243 7.80837 1.64951C7.74762 1.67472 7.69245 1.71166 7.646 1.75822L5 4.40422C4.95344 4.45067 4.91649 4.50584 4.89129 4.56659C4.86608 4.62733 4.85311 4.69246 4.85311 4.75822C4.85311 4.82399 4.86608 4.88911 4.89129 4.94986C4.91649 5.0106 4.95344 5.06578 5 5.11222Z" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8 2.25781C8.13261 2.25781 8.25979 2.31049 8.35355 2.40426C8.44732 2.49803 8.5 2.6252 8.5 2.75781V10.7578C8.5 10.8904 8.44732 11.0176 8.35355 11.1114C8.25979 11.2051 8.13261 11.2578 8 11.2578C7.86739 11.2578 7.74021 11.2051 7.64645 11.1114C7.55268 11.0176 7.5 10.8904 7.5 10.7578V2.75781C7.5 2.6252 7.55268 2.49803 7.64645 2.40426C7.74021 2.31049 7.86739 2.25781 8 2.25781Z" />
                      </svg> <span i18n="@@profile-storelogo.store-logos-tab.upload-logo">Upload Logo</span></span>
                  </label>
                  <ng-template #popContent>
                    <div class="popover-upload-req" id="popContentUpload">
                      <div class="d-flex align-items-center" id="popContentFlex">
                        <img src="assets/images/image-icon.png" alt="image" />
                        <ul>
                          <li i18n="@@global.tooltip.image-rule-format">Images must be in <strong>JPG, PNG, JPEG, JFIF</strong> or
                            <strong>GIF</strong> format</li>
                          <li><span i18n="@@global.tooltip.image-max-size-error">Allowed maximum size is <strong>5 MB</strong></span></li>
                        </ul>
                      </div>
                    </div>
                  </ng-template>
                  <img class="info_icon" src="assets/images/info_circle_icon.svg" alt="hover for help" 
                    [ngbPopover]="popContent" triggers="mouseenter:mouseleave" />
                  </div>
                    <div id="isImageFileErr" *ngIf="isImageTypeError" class="uploadfile_err_msg error-msg-width">
                      <span i18n="@@global.content-grp.image-rule-format">Incorrect file type received. Image must be in <strong>JPG, PNG</strong> or <strong>GIF</strong> format.</span></div>
                    <div id="uploadFIleErrMsg" *ngIf="isImageSizeError && isimageFormat" class="uploadfile_err_msg">
                      <span i18n="@@global.content-grp.image-max-size-error">File exceeds maximum size <strong>(5 MB).</strong></span></div>
                </div>
              </div>
            </div>
            <!---upload logo ends here-->        
            <div class="data_content" id="dataUploadLogoCon">
              <div class="border-right" id="storLogoLabelDiv" *ngIf="defaultStoreLogos?.length < 1 && otherStoreLogos?.length">
                <span class="logo_category">{{storeLogoLabel}}</span>
                <div class="default_logo_tile border-0" id="defaultLogoTile">

                  <div class="accordion" id="logoAccordion">
                    <div class="default_logos_border" id="defaultLogosBorder">
                      <div class="card" id="card">
                        <div class="default_img_icon" id="defaultImgIcon"></div>
                        <div class="default_card_text" id="defaultCardText"><span i18n="@@global.content-grp-set-logo.set-a-logo">Set a logo</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Default logo tile -->
              <div *ngIf="defaultStoreLogos?.length > 0 " id="defaultStoroLogosDiv">
                <span class="logo_category">{{storeLogoLabel}}</span>
                <div class="default_logo_tile border-0" id="defaultLogoTileDiv">
                  <!-- Default logo tile -->
                  <div *ngFor="let storeLogo of defaultStoreLogos">
                    <div class="card" [ngStyle]="{'background-color':storeLogoBgColor}">
                      <button type="button" (click)="setAsDefaultStoreLogo(storeLogo.id, true)">
                        <div class="store_logo_img" id="storeLogoImg">
                        <img [src]="storeLogo.imageData" class="store_logo_image" alt="Image Logo" />
                        </div>
                      </button>
                      <!-- Color Picker -->

                      <div placement="top-left" ngbTooltip={{storeLogo.fileName}}
                        class="small_text p-t10 store_logo_caption " id="storeLogoCaption">{{storeLogo.shortFileName}}</div>
                    </div>

                    <div class="default_logo_action" id="defaultLogoAction">
                      <div id="storLogoBGColor" class="form-group" *ngIf="otherStoreLogos?.length || defaultStoreLogos?.length">
                        <label for=""><span i18n="@@devices-storelogo.devices-action.select-background-color">Background
                            color</span></label>
                        <div id="colorPickerBtnDefault">
                          <input [(colorPicker)]="storeLogoBgColor" [ngStyle]="{'background-color':storeLogoBgColor}"
                            (colorPickerChange)="updateBgColor($event)" class="color_picker_button default"
                            name="bgcolor" readonly />
                        </div>
                      </div>
                      <div class="action_buttons" *ngIf='removeButton' id="actionBtns">
                        <button type="button" (click)="setAsDefaultStoreLogo(storeLogo.id, false)"
                          class="btn btn-block  btn-outline-primary btn-sm ">
                          <span i18n="@@profile-storelogo.clear-selection-logo.clear-selection">Clear Selection</span>
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- Default logo tile/card ends here -->
                </div>
              </div>

              <div class="other_logos_column" *ngIf="otherStoreLogos && otherStoreLogos?.length" id="otherStoreLogos">

                <div class="other_logos_tiles" id="otherLogosTilesMain">
                  <div class="other_logos_column" id="otherLogosColumn">
                    <span class="logo_category" i18n="@@devices-storelogo.devices-action.other-logos">Other logos</span>
                    <div class="other_logos_tiles" id="otherLogosTilesChild">
                      <div #container class="scrollerPreNext d-flex flex-row">
                        <div class="card" *ngFor="let storeLogo of otherStoreLogos" (click)="setStoreLogo(storeLogo)" id="storeLogoCard">
                          <div class="store_logo_img" id="storeLogoImgChild">
                          <img class="store_logo_image" [src]="storeLogo.imageData" alt="Image Logo" />
                          </div>  
                          <div placement="top-left" container='body' ngbTooltip={{storeLogo.fileName}}
                            class="store_logo_caption small_text" id="storeLogoCaptionChild">{{storeLogo.shortFileName}}</div>
                        </div>
                      </div>
                      <span class="slide_prev" (click)="scrollNext()"  *ngIf="(otherStoreLogos?.length <=1)? '':'display-block'">
                        <div class="slide_prev_btn" id="slidePrevBtn">
                          <img class="slide_prev_img"  alt="slide previous">
                        </div>
                      </span>
                      <span class="slide_next" (click)="scrollPrev()" *ngIf="(otherStoreLogos?.length <=1)? '':'display-block'">
                        <div class="slide_next_btn" id="slideNextBtn">
                          <img  class="slide_prev_img" alt="slide next">
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <hr />
<div  *ngIf="( this.defaultStoreLogos.length >= 1 || otherStoreLogos.length >= 1 ) ? 'display-block' : ''" id="storeLogosDisplayBlock">
          <div class="device_small_text" id="deviceSmallText"><span i18n="@@devices-storelogo.devices-action-title.logo-content-group">Logo
              Content Group</span></div>
          <div class="device_grey_color" id="deviceGreyColor"><span i18n="@@devices-storelogo.devices-action-title.add-logo-group">Add a logo content 
            group of up to 3 pages to your logo.</span>
          </div>
          <!--new logo content group button starts-->
          <div class="data_action mt-3" *ngIf="(logoContentLength > 0 )? '' : 'display-block' " id="uploadLogoBtnAction">
            <button type="button"  id="uploadLogo"  class="btn btn-primary btn-sm left_icon_btn gtmAssetLibraryLogoContentCreateNewLogoContent"
              (click)="createNewLogoContent()">
              <svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0)">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 3.5C8.63261 3.5 8.75979 3.55268 8.85355 3.64645C8.94732 3.74021 9 3.86739 9 4V8C9 8.13261 8.94732 8.25979 8.85355 8.35355C8.75979 8.44732 8.63261 8.5 8.5 8.5H4.5C4.36739 8.5 4.24021 8.44732 4.14645 8.35355C4.05268 8.25979 4 8.13261 4 8C4 7.86739 4.05268 7.74021 4.14645 7.64645C4.24021 7.55268 4.36739 7.5 4.5 7.5H8V4C8 3.86739 8.05268 3.74021 8.14645 3.64645C8.24021 3.55268 8.36739 3.5 8.5 3.5Z" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8 8C8 7.86739 8.05268 7.74021 8.14645 7.64645C8.24021 7.55268 8.36739 7.5 8.5 7.5H12.5C12.6326 7.5 12.7598 7.55268 12.8536 7.64645C12.9473 7.74021 13 7.86739 13 8C13 8.13261 12.9473 8.25979 12.8536 8.35355C12.7598 8.44732 12.6326 8.5 12.5 8.5H9V12C9 12.1326 8.94732 12.2598 8.85355 12.3536C8.75979 12.4473 8.63261 12.5 8.5 12.5C8.36739 12.5 8.24021 12.4473 8.14645 12.3536C8.05268 12.2598 8 12.1326 8 12V8Z"
                    fill="white" />
                  <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M8.5 15C10.3565 15 12.137 14.2625 13.4497 12.9497C14.7625 11.637 15.5 9.85652 15.5 8C15.5 6.14348 14.7625 4.36301 13.4497 3.05025C12.137 1.7375 10.3565 1 8.5 1C6.64348 1 4.86301 1.7375 3.55025 3.05025C2.2375 4.36301 1.5 6.14348 1.5 8C1.5 9.85652 2.2375 11.637 3.55025 12.9497C4.86301 14.2625 6.64348 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z" />
                </g>
                <defs>
                  <clipPath id="clip0">
                    <rect width="16" height="16" transform="translate(0.5)" />
                  </clipPath>
                </defs>
              </svg>
              <span i18n="@@logo-content.logo-content-groups.new-logo-content-groups" >New Logo Content Group</span>
            </button>
          </div>
          <!--new logo button ends-->
          <iposcen-logo-content class="deviceContWrapper" (deviceLogoContentId)='getLogoId($event)'
          (logoContentLength)='logoContentLength = $event'   [deviceStoreLogoOtherData]='storeLogoOtherData'>
          </iposcen-logo-content>
          <!-- Buttons -->
          <div class="button-wrapper justify-content-end" id="btnWrapper">
            <button type="button" class="btn btn-primary" (click)="sendToUpdateAllDevices(send)"
              [disabled]="(this.defaultStoreLogos.length === 0 || isLogoSelected) || !isRetailerId">
              <span i18n="@@devices-storelogo.devices-action-button.update-all-devices">Update All Devices</span>
            </button>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- IIT2-1510 -->
<div class="container" id="containerMainDiv">
  <div class="modal-dialog-centered" *ngIf="openModalPopup" id="modalDialog">
    <div class="modal-backdrop show" id="modalBackdrop"></div>
    <div class="modal" id="myModalSuccess">
      <div class="modal-dialog" id="myModalSuccessDialog">
        <div class="modal-content" id="myModalSuccessContent">
          <div _ngcontent-fjy-c198="" class="close" (click)="closePopup()" id="myModalSuccessClose"><img _ngcontent-fjy-c198="" alt="close"
              class="modal-close-icon"></div>
          <div class="modal-body" id="myModalSuccessCloseBody">
            <div class="action_on_pending_user" id="actionOnPendingUsr">
              <span class="success_img"></span>
            </div>
            <div class="action-success-msg" id="actionSuccessMsg">
              <span>{{successMessage}}</span>
            </div>
            <div class="card_desc" id="cardDesc">
              <span>{{description}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- IIT2-1510 end -->